export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },  
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      `@/views/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/views/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/tablero',
    meta: { 
        breadcrumb: true,
        requiresAuth: true
    },
    name: 'Tablero', 
    component: () => import(
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/logout',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'logOut',
    component: () => import(
      `@/views/Logout.vue`
    ),
  },
  {
    path: '/usuarios',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'Usuarios',
    component: () => import(
      `@/views/users/Main.vue`
    ),
  },
  
 
  {
    path: '/data/nueva-data',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'NewData',
    component: () => import(
      `@/views/data/Main_.vue`
    ),
  },
  {
    path: '/data/historial',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataHistory',
    component: () => import(
      `@/views/data/History.vue`
    ),
  },
  
  {
    path: '/data/ver-detalle/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'historyDetail',
    component: () => import(
      `@/views/data/Detail.vue`
    ),
  },
  {
    path: '/data/editar/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataEdit',
    component: () => import(
      `@/views/data/Edit.vue`
    ),
  },
  {
    path: '/data/crear',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataCreate',
    component: () => import(
      `@/views/data/Create.vue`
    ),
  },



{
    path: '/GN/data-gn/nueva-data-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'NewDataGN',
    component: () => import(
      `@/views/dataGN/Main_.vue`
    ),
  },
  {
    path: '/GN/data-gn/historial-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataHistoryGN',
    component: () => import(
      `@/views/dataGN/History.vue`
    ),
  },
  
  {
    path: '/GN/data-gn/ver-detalle-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'historyDetailGN',
    component: () => import(
      `@/views/dataGN/Detail.vue`
    ),
  },
  {
    path: '/GN/data-gn/editar-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataEditGN',
    component: () => import(
      `@/views/dataGN/Edit.vue`
    ),
  },
  {
    path: '/GN/data-gn/crear-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'dataCreateGN',
    component: () => import(
      `@/views/dataGN/Create.vue`
    ),
  },





  {
    path: '/data/agents',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'Agentes',
    component: () => import(
      `@/views/agents/agents.vue`
    ),
  },

   {
    path: '/data/agents/agents-detail/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agentsDetail',
    component: () => import(
      `@/views/agents/agents-detail.vue`
    ),
  },




  {
    path: '/GN/data-gn/agents-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'AgentesGN',
    component: () => import(
      `@/views/agentsGN/agents.vue`
    ),
  },

   {
    path: '/GN/data-gn/agents/agents-detail-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agentsDetailGN',
    component: () => import(
      `@/views/agentsGN/agents-detail.vue`
    ),
  },



//nuevas rutas

  {
    path: '/documentos-archivo/crear',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoCrear',
    component: () => import(
      `@/views/agenteArchivo/Crear.vue`
    ),
  },

  {
    path: '/GN/documentos-archivo-gn/crear-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoCrearGN',
    component: () => import(
      `@/views/agenteArchivoGN/Crear.vue`
    ),
  },


  {
    path: '/agente-archivo/historial',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoHistoria',
    component: () => import(
      `@/views/agenteArchivo/Historia.vue`
    ),
  },


  {
    path: '/GN/agente-archivo-gn/historial-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoHistoriaGN',
    component: () => import(
      `@/views/agenteArchivoGN/Historia.vue`
    ),
  },

  {
    path: '/agente-archivo/ver-detalle/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoDetalle',
    component: () => import(
      `@/views/agenteArchivo/Detalle.vue`
    ),
  },

  {
    path: '/GN/agente-archivo-gn/ver-detalle-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoDetalleGN',
    component: () => import(
      `@/views/agenteArchivoGN/Detalle.vue`
    ),
  },


  {
    path: '/agente-archivo/editar/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoEditar',
    component: () => import(
      `@/views/agenteArchivo/Editar.vue`
    ),
  },

  {
    path: '/GN/agente-archivo-gn/editar-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'agenteArchivoEditarGN',
    component: () => import(
      `@/views/agenteArchivoGN/Editar.vue`
    ),
  },

  {
    path: '/archivos',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'Archivos',
    component: () => import(
      `@/views/agenteArchivo/Archivo.vue`
    ),
  },


  {
    path: '/GN/archivos-gn',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'ArchivosGN',
    component: () => import(
      `@/views/agenteArchivoGN/Archivo.vue`
    ),
  },

  {
    path: '/archivos/archivo-detalle/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'ArchivoDetalle',
    component: () => import(
      `@/views/agenteArchivo/DetalleArchivo.vue`
    ),
  },

  {
    path: '/GN/archivos-gn/archivo-detalle-gn/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'ArchivoDetalleGN',
    component: () => import(
      `@/views/agenteArchivoGN/DetalleArchivo.vue`
    ),
  },

  //nuevvas rutas CRUD cajero Atm

   {
    path: '/GN/cajero-gn/nuevo',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'CajeroCreateGN',
    component: () => import(
      `@/views/cajeroGN/crear.vue`
    ),
  },

  {
    path: '/GN/cajero-gn/modificar/:id?',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'CajeroModificarGN',
    component: () => import(
      `@/views/cajeroGN/editar.vue`
    ),
  },

  {
    path: '/GN/cajero-gn/listado',
    meta: { 
        breadcrumb: true,
        requiresAuth: true 
    },
    name: 'CajeroListadoGN',
    component: () => import(
      `@/views/cajeroGN/listado.vue`
    ),
  }

];


